module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/zh-hans-57fd5252495091c7e544777795f7790d.jpg";